export enum PatchOperation {
    test,
    remove,
    add,
    replace,
    move,
    copy
}

export interface JsonPatchBody {
    op: PatchOperation;
    path: string;
    value: any;
}